import { put, fork, call, takeEvery, all } from 'redux-saga/effects';
import app from '../../app';
import { loadNewUserProdcutListCompletion } from '../../actions';

export function* watchLoadNewUserProdcutList() {
  yield takeEvery('LOAD_NEWUSER_PRODUCT_LIST', function*() {
    const options = {
      url: '/api/xg/topic/new',
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadNewUserProdcutListCompletion(
        result.error,
        (result.data && result.data.listData) || [],
        (result.data && result.data.topicVo) || null
      )
    );
  });
}

export default function* newUserSaga() {
  yield all([fork(watchLoadNewUserProdcutList)]);
}
